import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.467 8.467" {...props}>
    <path
      d="M4.297.265a.265.265 0 00-.027 0 .265.265 0 00-.22.143l-1.126 2.19-2.428.306a.265.265 0 00-.156.447L2.06 5.11l-.462 2.422a.265.265 0 00.379.287l2.187-1.103 2.145 1.19a.265.265 0 00.388-.27l-.365-2.442 1.787-1.685a.265.265 0 00-.139-.455L5.567 2.65 4.527.418a.265.265 0 00-.23-.153z"
      fill="currentColor"
    />
  </svg>
);

const IconStar: React.FC<IIcon> = (props: ReactProps) => <Icon {...props} svg={svg} />;

export default IconStar;
